<div class="personal_dictionary_section">
    <div class="media align-items-center">
        <div class="media-left">
            <h4>Spelling <span>+ Add to Dictionary</span></h4>
            <h6>
                <span>{{ word1 }}</span>
                <svg width="24px" height="24px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M4 12H20M20 12L14 6M20 12L14 18" stroke="#1C274C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg>
                <span>{{ word2 }}</span>
            </h6>
            <p>
                <span>Accept for all similar alerts</span>
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15Z" stroke="#4f4f4f" stroke-width="0.8" stroke-miterlimit="10"/>
                    <path d="M7.99299 4.08002C7.81538 4.08002 7.67099 4.2244 7.67099 4.40202C7.67099 4.57963 7.81538 4.72402 7.99299 4.72402C8.1706 4.72402 8.31499 4.57963 8.31499 4.40202C8.31499 4.2244 8.1706 4.08002 7.99299 4.08002Z" fill="#763393" stroke="#763393" stroke-width="0.8" stroke-miterlimit="10"/>
                    <path d="M8.00118 12.3436C8.07783 12.3436 8.13997 12.2815 8.13997 12.2049V6.43597C8.13997 6.21896 8.12447 6.04364 8.10529 6.04364H7.89465C7.87547 6.04364 7.85997 6.21896 7.85997 6.43597L7.8624 8.39951V12.2049C7.8624 12.2815 7.92454 12.3436 8.00118 12.3436V12.3436Z" stroke="#763393" stroke-width="0.8" stroke-miterlimit="10"/>
                </svg>
            </p>
            <small class="d-block text-start">Please check the spelling</small>
        </div>
        <div class="media-body">
            <ul>
                <li><img src="assets/images/chevron-up.svg" loading="lazy" alt="arrow up" /></li>
                <li>
                    <img src="assets/images/Consistency_delete_icon.svg" loading="lazy" alt="Delete" style="width: 22px;">
                </li>
                <li class="acceptAll_rejectAll">
                    <img src="assets/images/AcceptAll_consistencyCheks.svg" loading="lazy" alt="Ignore for all similar aterls" style="width: 22px;">
                </li>
                <li>
                    <img src="assets/images/consistency_dislike_icon.svg" loading="lazy" alt="Incorrect suggestions" style="width: 20px;">
                </li>
            </ul>
        </div>
    </div>
</div>